"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _GeometryLayout = _interopRequireDefault(require("./GeometryLayout.js"));

var _GeometryType = _interopRequireDefault(require("./GeometryType.js"));

var _SimpleGeometry = _interopRequireDefault(require("./SimpleGeometry.js"));

var _closest = require("./flat/closest.js");

var _extent = require("../extent.js");

var _deflate = require("./flat/deflate.js");

var _simplify = require("./flat/simplify.js");

var _array = require("../array.js");

var _segments = require("./flat/segments.js");

var _inflate = require("./flat/inflate.js");

var _interpolate = require("./flat/interpolate.js");

var _intersectsextent = require("./flat/intersectsextent.js");

var _length = require("./flat/length.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var __extends = void 0 && (void 0).__extends || function () {
  var _extendStatics = function extendStatics(d, b) {
    _extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) {
        if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
      }
    };

    return _extendStatics(d, b);
  };

  return function (d, b) {
    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");

    _extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();
/**
 * @module ol/geom/LineString
 */


/**
 * @classdesc
 * Linestring geometry.
 *
 * @api
 */
var LineString =
/** @class */
function (_super) {
  __extends(LineString, _super);
  /**
   * @param {Array<import("../coordinate.js").Coordinate>|Array<number>} coordinates Coordinates.
   *     For internal use, flat coordinates in combination with `opt_layout` are also accepted.
   * @param {import("./GeometryLayout.js").default} [opt_layout] Layout.
   */


  function LineString(coordinates, opt_layout) {
    var _this = _super.call(this) || this;
    /**
     * @private
     * @type {import("../coordinate.js").Coordinate}
     */


    _this.flatMidpoint_ = null;
    /**
     * @private
     * @type {number}
     */

    _this.flatMidpointRevision_ = -1;
    /**
     * @private
     * @type {number}
     */

    _this.maxDelta_ = -1;
    /**
     * @private
     * @type {number}
     */

    _this.maxDeltaRevision_ = -1;

    if (opt_layout !== undefined && !Array.isArray(coordinates[0])) {
      _this.setFlatCoordinates(opt_layout,
      /** @type {Array<number>} */
      coordinates);
    } else {
      _this.setCoordinates(
      /** @type {Array<import("../coordinate.js").Coordinate>} */
      coordinates, opt_layout);
    }

    return _this;
  }
  /**
   * Append the passed coordinate to the coordinates of the linestring.
   * @param {import("../coordinate.js").Coordinate} coordinate Coordinate.
   * @api
   */


  LineString.prototype.appendCoordinate = function (coordinate) {
    if (!this.flatCoordinates) {
      this.flatCoordinates = coordinate.slice();
    } else {
      (0, _array.extend)(this.flatCoordinates, coordinate);
    }

    this.changed();
  };
  /**
   * Make a complete copy of the geometry.
   * @return {!LineString} Clone.
   * @api
   */


  LineString.prototype.clone = function () {
    var lineString = new LineString(this.flatCoordinates.slice(), this.layout);
    lineString.applyProperties(this);
    return lineString;
  };
  /**
   * @param {number} x X.
   * @param {number} y Y.
   * @param {import("../coordinate.js").Coordinate} closestPoint Closest point.
   * @param {number} minSquaredDistance Minimum squared distance.
   * @return {number} Minimum squared distance.
   */


  LineString.prototype.closestPointXY = function (x, y, closestPoint, minSquaredDistance) {
    if (minSquaredDistance < (0, _extent.closestSquaredDistanceXY)(this.getExtent(), x, y)) {
      return minSquaredDistance;
    }

    if (this.maxDeltaRevision_ != this.getRevision()) {
      this.maxDelta_ = Math.sqrt((0, _closest.maxSquaredDelta)(this.flatCoordinates, 0, this.flatCoordinates.length, this.stride, 0));
      this.maxDeltaRevision_ = this.getRevision();
    }

    return (0, _closest.assignClosestPoint)(this.flatCoordinates, 0, this.flatCoordinates.length, this.stride, this.maxDelta_, false, x, y, closestPoint, minSquaredDistance);
  };
  /**
   * Iterate over each segment, calling the provided callback.
   * If the callback returns a truthy value the function returns that
   * value immediately. Otherwise the function returns `false`.
   *
   * @param {function(this: S, import("../coordinate.js").Coordinate, import("../coordinate.js").Coordinate): T} callback Function
   *     called for each segment. The function will receive two arguments, the start and end coordinates of the segment.
   * @return {T|boolean} Value.
   * @template T,S
   * @api
   */


  LineString.prototype.forEachSegment = function (callback) {
    return (0, _segments.forEach)(this.flatCoordinates, 0, this.flatCoordinates.length, this.stride, callback);
  };
  /**
   * Returns the coordinate at `m` using linear interpolation, or `null` if no
   * such coordinate exists.
   *
   * `opt_extrapolate` controls extrapolation beyond the range of Ms in the
   * MultiLineString. If `opt_extrapolate` is `true` then Ms less than the first
   * M will return the first coordinate and Ms greater than the last M will
   * return the last coordinate.
   *
   * @param {number} m M.
   * @param {boolean} [opt_extrapolate] Extrapolate. Default is `false`.
   * @return {import("../coordinate.js").Coordinate|null} Coordinate.
   * @api
   */


  LineString.prototype.getCoordinateAtM = function (m, opt_extrapolate) {
    if (this.layout != _GeometryLayout["default"].XYM && this.layout != _GeometryLayout["default"].XYZM) {
      return null;
    }

    var extrapolate = opt_extrapolate !== undefined ? opt_extrapolate : false;
    return (0, _interpolate.lineStringCoordinateAtM)(this.flatCoordinates, 0, this.flatCoordinates.length, this.stride, m, extrapolate);
  };
  /**
   * Return the coordinates of the linestring.
   * @return {Array<import("../coordinate.js").Coordinate>} Coordinates.
   * @api
   */


  LineString.prototype.getCoordinates = function () {
    return (0, _inflate.inflateCoordinates)(this.flatCoordinates, 0, this.flatCoordinates.length, this.stride);
  };
  /**
   * Return the coordinate at the provided fraction along the linestring.
   * The `fraction` is a number between 0 and 1, where 0 is the start of the
   * linestring and 1 is the end.
   * @param {number} fraction Fraction.
   * @param {import("../coordinate.js").Coordinate} [opt_dest] Optional coordinate whose values will
   *     be modified. If not provided, a new coordinate will be returned.
   * @return {import("../coordinate.js").Coordinate} Coordinate of the interpolated point.
   * @api
   */


  LineString.prototype.getCoordinateAt = function (fraction, opt_dest) {
    return (0, _interpolate.interpolatePoint)(this.flatCoordinates, 0, this.flatCoordinates.length, this.stride, fraction, opt_dest, this.stride);
  };
  /**
   * Return the length of the linestring on projected plane.
   * @return {number} Length (on projected plane).
   * @api
   */


  LineString.prototype.getLength = function () {
    return (0, _length.lineStringLength)(this.flatCoordinates, 0, this.flatCoordinates.length, this.stride);
  };
  /**
   * @return {Array<number>} Flat midpoint.
   */


  LineString.prototype.getFlatMidpoint = function () {
    if (this.flatMidpointRevision_ != this.getRevision()) {
      this.flatMidpoint_ = this.getCoordinateAt(0.5, this.flatMidpoint_);
      this.flatMidpointRevision_ = this.getRevision();
    }

    return this.flatMidpoint_;
  };
  /**
   * @param {number} squaredTolerance Squared tolerance.
   * @return {LineString} Simplified LineString.
   * @protected
   */


  LineString.prototype.getSimplifiedGeometryInternal = function (squaredTolerance) {
    var simplifiedFlatCoordinates = [];
    simplifiedFlatCoordinates.length = (0, _simplify.douglasPeucker)(this.flatCoordinates, 0, this.flatCoordinates.length, this.stride, squaredTolerance, simplifiedFlatCoordinates, 0);
    return new LineString(simplifiedFlatCoordinates, _GeometryLayout["default"].XY);
  };
  /**
   * Get the type of this geometry.
   * @return {import("./GeometryType.js").default} Geometry type.
   * @api
   */


  LineString.prototype.getType = function () {
    return _GeometryType["default"].LINE_STRING;
  };
  /**
   * Test if the geometry and the passed extent intersect.
   * @param {import("../extent.js").Extent} extent Extent.
   * @return {boolean} `true` if the geometry and the extent intersect.
   * @api
   */


  LineString.prototype.intersectsExtent = function (extent) {
    return (0, _intersectsextent.intersectsLineString)(this.flatCoordinates, 0, this.flatCoordinates.length, this.stride, extent);
  };
  /**
   * Set the coordinates of the linestring.
   * @param {!Array<import("../coordinate.js").Coordinate>} coordinates Coordinates.
   * @param {import("./GeometryLayout.js").default} [opt_layout] Layout.
   * @api
   */


  LineString.prototype.setCoordinates = function (coordinates, opt_layout) {
    this.setLayout(opt_layout, coordinates, 1);

    if (!this.flatCoordinates) {
      this.flatCoordinates = [];
    }

    this.flatCoordinates.length = (0, _deflate.deflateCoordinates)(this.flatCoordinates, 0, coordinates, this.stride);
    this.changed();
  };

  return LineString;
}(_SimpleGeometry["default"]);

var _default = LineString;
exports["default"] = _default;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJtYXBwaW5ncyI6Ijs7Ozs7OztBQUdBOztBQUNBOztBQUNBOztBQUNBOztBQUNBOztBQUNBOztBQUNBOztBQUNBOztBQUNBOztBQUNBOztBQUNBOztBQUNBOztBQUNBOzs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7O0FBZkE7Ozs7O0FBaUJBOzs7Ozs7QUFNQTtBQUFBO0FBQUE7RUFBeUJBO0VBQ3ZCOzs7Ozs7O0VBS0Esb0JBQVlDLFdBQVosRUFBeUJDLFVBQXpCLEVBQW1DO0lBQW5DLFlBQ0VDLHFCQUFPLElBRFQ7SUFHRTs7Ozs7O0lBSUFDLEtBQUksQ0FBQ0MsYUFBTCxHQUFxQixJQUFyQjtJQUVBOzs7OztJQUlBRCxLQUFJLENBQUNFLHFCQUFMLEdBQTZCLENBQUMsQ0FBOUI7SUFFQTs7Ozs7SUFJQUYsS0FBSSxDQUFDRyxTQUFMLEdBQWlCLENBQUMsQ0FBbEI7SUFFQTs7Ozs7SUFJQUgsS0FBSSxDQUFDSSxpQkFBTCxHQUF5QixDQUFDLENBQTFCOztJQUVBLElBQUlOLFVBQVUsS0FBS08sU0FBZixJQUE0QixDQUFDQyxLQUFLLENBQUNDLE9BQU4sQ0FBY1YsV0FBVyxDQUFDLENBQUQsQ0FBekIsQ0FBakMsRUFBZ0U7TUFDOURHLEtBQUksQ0FBQ1Esa0JBQUwsQ0FDRVYsVUFERjtNQUVFO01BQThCRCxXQUZoQztJQUlELENBTEQsTUFLTztNQUNMRyxLQUFJLENBQUNTLGNBQUw7TUFDRTtNQUNFWixXQUZKLEVBSUVDLFVBSkY7SUFNRDs7O0VBQ0Y7RUFFRDs7Ozs7OztFQUtBWSxrREFBaUJDLFVBQWpCLEVBQTJCO0lBQ3pCLElBQUksQ0FBQyxLQUFLQyxlQUFWLEVBQTJCO01BQ3pCLEtBQUtBLGVBQUwsR0FBdUJELFVBQVUsQ0FBQ0UsS0FBWCxFQUF2QjtJQUNELENBRkQsTUFFTztNQUNMLG1CQUFPLEtBQUtELGVBQVosRUFBNkJELFVBQTdCO0lBQ0Q7O0lBQ0QsS0FBS0csT0FBTDtFQUNELENBUEQ7RUFTQTs7Ozs7OztFQUtBSjtJQUNFLElBQU1LLFVBQVUsR0FBRyxJQUFJTCxVQUFKLENBQ2pCLEtBQUtFLGVBQUwsQ0FBcUJDLEtBQXJCLEVBRGlCLEVBRWpCLEtBQUtHLE1BRlksQ0FBbkI7SUFJQUQsVUFBVSxDQUFDRSxlQUFYLENBQTJCLElBQTNCO0lBQ0EsT0FBT0YsVUFBUDtFQUNELENBUEQ7RUFTQTs7Ozs7Ozs7O0VBT0FMLGdEQUFlUSxDQUFmLEVBQWtCQyxDQUFsQixFQUFxQkMsWUFBckIsRUFBbUNDLGtCQUFuQyxFQUFxRDtJQUNuRCxJQUFJQSxrQkFBa0IsR0FBRyxzQ0FBeUIsS0FBS0MsU0FBTCxFQUF6QixFQUEyQ0osQ0FBM0MsRUFBOENDLENBQTlDLENBQXpCLEVBQTJFO01BQ3pFLE9BQU9FLGtCQUFQO0lBQ0Q7O0lBQ0QsSUFBSSxLQUFLakIsaUJBQUwsSUFBMEIsS0FBS21CLFdBQUwsRUFBOUIsRUFBa0Q7TUFDaEQsS0FBS3BCLFNBQUwsR0FBaUJxQixJQUFJLENBQUNDLElBQUwsQ0FDZiw4QkFDRSxLQUFLYixlQURQLEVBRUUsQ0FGRixFQUdFLEtBQUtBLGVBQUwsQ0FBcUJjLE1BSHZCLEVBSUUsS0FBS0MsTUFKUCxFQUtFLENBTEYsQ0FEZSxDQUFqQjtNQVNBLEtBQUt2QixpQkFBTCxHQUF5QixLQUFLbUIsV0FBTCxFQUF6QjtJQUNEOztJQUNELE9BQU8saUNBQ0wsS0FBS1gsZUFEQSxFQUVMLENBRkssRUFHTCxLQUFLQSxlQUFMLENBQXFCYyxNQUhoQixFQUlMLEtBQUtDLE1BSkEsRUFLTCxLQUFLeEIsU0FMQSxFQU1MLEtBTkssRUFPTGUsQ0FQSyxFQVFMQyxDQVJLLEVBU0xDLFlBVEssRUFVTEMsa0JBVkssQ0FBUDtFQVlELENBNUJEO0VBOEJBOzs7Ozs7Ozs7Ozs7O0VBV0FYLGdEQUFla0IsUUFBZixFQUF1QjtJQUNyQixPQUFPLHVCQUNMLEtBQUtoQixlQURBLEVBRUwsQ0FGSyxFQUdMLEtBQUtBLGVBQUwsQ0FBcUJjLE1BSGhCLEVBSUwsS0FBS0MsTUFKQSxFQUtMQyxRQUxLLENBQVA7RUFPRCxDQVJEO0VBVUE7Ozs7Ozs7Ozs7Ozs7Ozs7RUFjQWxCLGtEQUFpQm1CLENBQWpCLEVBQW9CQyxlQUFwQixFQUFtQztJQUNqQyxJQUNFLEtBQUtkLE1BQUwsSUFBZWUsMkJBQWVDLEdBQTlCLElBQ0EsS0FBS2hCLE1BQUwsSUFBZWUsMkJBQWVFLElBRmhDLEVBR0U7TUFDQSxPQUFPLElBQVA7SUFDRDs7SUFDRCxJQUFNQyxXQUFXLEdBQUdKLGVBQWUsS0FBS3pCLFNBQXBCLEdBQWdDeUIsZUFBaEMsR0FBa0QsS0FBdEU7SUFDQSxPQUFPLDBDQUNMLEtBQUtsQixlQURBLEVBRUwsQ0FGSyxFQUdMLEtBQUtBLGVBQUwsQ0FBcUJjLE1BSGhCLEVBSUwsS0FBS0MsTUFKQSxFQUtMRSxDQUxLLEVBTUxLLFdBTkssQ0FBUDtFQVFELENBaEJEO0VBa0JBOzs7Ozs7O0VBS0F4QjtJQUNFLE9BQU8saUNBQ0wsS0FBS0UsZUFEQSxFQUVMLENBRkssRUFHTCxLQUFLQSxlQUFMLENBQXFCYyxNQUhoQixFQUlMLEtBQUtDLE1BSkEsQ0FBUDtFQU1ELENBUEQ7RUFTQTs7Ozs7Ozs7Ozs7O0VBVUFqQixpREFBZ0J5QixRQUFoQixFQUEwQkMsUUFBMUIsRUFBa0M7SUFDaEMsT0FBTyxtQ0FDTCxLQUFLeEIsZUFEQSxFQUVMLENBRkssRUFHTCxLQUFLQSxlQUFMLENBQXFCYyxNQUhoQixFQUlMLEtBQUtDLE1BSkEsRUFLTFEsUUFMSyxFQU1MQyxRQU5LLEVBT0wsS0FBS1QsTUFQQSxDQUFQO0VBU0QsQ0FWRDtFQVlBOzs7Ozs7O0VBS0FqQjtJQUNFLE9BQU8sOEJBQ0wsS0FBS0UsZUFEQSxFQUVMLENBRkssRUFHTCxLQUFLQSxlQUFMLENBQXFCYyxNQUhoQixFQUlMLEtBQUtDLE1BSkEsQ0FBUDtFQU1ELENBUEQ7RUFTQTs7Ozs7RUFHQWpCO0lBQ0UsSUFBSSxLQUFLUixxQkFBTCxJQUE4QixLQUFLcUIsV0FBTCxFQUFsQyxFQUFzRDtNQUNwRCxLQUFLdEIsYUFBTCxHQUFxQixLQUFLb0MsZUFBTCxDQUFxQixHQUFyQixFQUEwQixLQUFLcEMsYUFBL0IsQ0FBckI7TUFDQSxLQUFLQyxxQkFBTCxHQUE2QixLQUFLcUIsV0FBTCxFQUE3QjtJQUNEOztJQUNELE9BQU8sS0FBS3RCLGFBQVo7RUFDRCxDQU5EO0VBUUE7Ozs7Ozs7RUFLQVMsK0RBQThCNEIsZ0JBQTlCLEVBQThDO0lBQzVDLElBQU1DLHlCQUF5QixHQUFHLEVBQWxDO0lBQ0FBLHlCQUF5QixDQUFDYixNQUExQixHQUFtQyw4QkFDakMsS0FBS2QsZUFENEIsRUFFakMsQ0FGaUMsRUFHakMsS0FBS0EsZUFBTCxDQUFxQmMsTUFIWSxFQUlqQyxLQUFLQyxNQUo0QixFQUtqQ1csZ0JBTGlDLEVBTWpDQyx5QkFOaUMsRUFPakMsQ0FQaUMsQ0FBbkM7SUFTQSxPQUFPLElBQUk3QixVQUFKLENBQWU2Qix5QkFBZixFQUEwQ1IsMkJBQWVTLEVBQXpELENBQVA7RUFDRCxDQVpEO0VBY0E7Ozs7Ozs7RUFLQTlCO0lBQ0UsT0FBTytCLHlCQUFhQyxXQUFwQjtFQUNELENBRkQ7RUFJQTs7Ozs7Ozs7RUFNQWhDLGtEQUFpQmlDLE1BQWpCLEVBQXVCO0lBQ3JCLE9BQU8sNENBQ0wsS0FBSy9CLGVBREEsRUFFTCxDQUZLLEVBR0wsS0FBS0EsZUFBTCxDQUFxQmMsTUFIaEIsRUFJTCxLQUFLQyxNQUpBLEVBS0xnQixNQUxLLENBQVA7RUFPRCxDQVJEO0VBVUE7Ozs7Ozs7O0VBTUFqQyxnREFBZWIsV0FBZixFQUE0QkMsVUFBNUIsRUFBc0M7SUFDcEMsS0FBSzhDLFNBQUwsQ0FBZTlDLFVBQWYsRUFBMkJELFdBQTNCLEVBQXdDLENBQXhDOztJQUNBLElBQUksQ0FBQyxLQUFLZSxlQUFWLEVBQTJCO01BQ3pCLEtBQUtBLGVBQUwsR0FBdUIsRUFBdkI7SUFDRDs7SUFDRCxLQUFLQSxlQUFMLENBQXFCYyxNQUFyQixHQUE4QixpQ0FDNUIsS0FBS2QsZUFEdUIsRUFFNUIsQ0FGNEIsRUFHNUJmLFdBSDRCLEVBSTVCLEtBQUs4QixNQUp1QixDQUE5QjtJQU1BLEtBQUtiLE9BQUw7RUFDRCxDQVpEOztFQWFGO0FBQUMsQ0FsU0QsQ0FBeUIrQiwwQkFBekI7O2VBb1NlbkMsVSIsIm5hbWVzIjpbIl9fZXh0ZW5kcyIsImNvb3JkaW5hdGVzIiwib3B0X2xheW91dCIsIl9zdXBlciIsIl90aGlzIiwiZmxhdE1pZHBvaW50XyIsImZsYXRNaWRwb2ludFJldmlzaW9uXyIsIm1heERlbHRhXyIsIm1heERlbHRhUmV2aXNpb25fIiwidW5kZWZpbmVkIiwiQXJyYXkiLCJpc0FycmF5Iiwic2V0RmxhdENvb3JkaW5hdGVzIiwic2V0Q29vcmRpbmF0ZXMiLCJMaW5lU3RyaW5nIiwiY29vcmRpbmF0ZSIsImZsYXRDb29yZGluYXRlcyIsInNsaWNlIiwiY2hhbmdlZCIsImxpbmVTdHJpbmciLCJsYXlvdXQiLCJhcHBseVByb3BlcnRpZXMiLCJ4IiwieSIsImNsb3Nlc3RQb2ludCIsIm1pblNxdWFyZWREaXN0YW5jZSIsImdldEV4dGVudCIsImdldFJldmlzaW9uIiwiTWF0aCIsInNxcnQiLCJsZW5ndGgiLCJzdHJpZGUiLCJjYWxsYmFjayIsIm0iLCJvcHRfZXh0cmFwb2xhdGUiLCJHZW9tZXRyeUxheW91dCIsIlhZTSIsIlhZWk0iLCJleHRyYXBvbGF0ZSIsImZyYWN0aW9uIiwib3B0X2Rlc3QiLCJnZXRDb29yZGluYXRlQXQiLCJzcXVhcmVkVG9sZXJhbmNlIiwic2ltcGxpZmllZEZsYXRDb29yZGluYXRlcyIsIlhZIiwiR2VvbWV0cnlUeXBlIiwiTElORV9TVFJJTkciLCJleHRlbnQiLCJzZXRMYXlvdXQiLCJTaW1wbGVHZW9tZXRyeSJdLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi9zcmMvZ2VvbS9MaW5lU3RyaW5nLmpzIl0sInNvdXJjZXNDb250ZW50IjpbbnVsbF19